import React from 'react';
import { Add } from '@mui/icons-material';
import { Box, Breadcrumbs, Button, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { adminColors, adminTypography } from '../../../../styles/adminDesignTokens';
import {
  adminButtonSx,
  adminButtonToneSx,
  adminCombineSx,
  adminPageHeaderSx,
  adminTextLinkSx,
} from '../../../../styles/adminComponentStyles';

interface StateGamesHeaderProps {
  stateLabel: string;
  totalGames: number;
  onCreateGame: () => void;
}

const StateGamesHeader: React.FC<StateGamesHeaderProps> = ({
  stateLabel,
  totalGames,
  onCreateGame,
}) => (
  <>
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{
        mb: 1,
        '& .MuiBreadcrumbs-separator': {
          color: adminColors.subtleText,
          fontSize: adminTypography.helper.fontSize,
        },
      }}
    >
      <Link
        component={RouterLink}
        underline="hover"
        to="/dashboard/games"
        sx={adminTextLinkSx}
      >
        Games
      </Link>
      <Typography sx={{ ...adminTypography.bodyStrong, color: adminColors.text }}>
        {stateLabel}
      </Typography>
    </Breadcrumbs>

    <Box sx={adminCombineSx(adminPageHeaderSx, { pt: 0 })}>
      <Box>
        <Typography className="AdminPageHeader-title">
          All Games
          <Box component="span" sx={{ color: adminColors.primary }}>
            {' '}({totalGames})
          </Box>
        </Typography>
      </Box>
      <Stack direction={{ xs: 'column', lg: 'row' }} spacing={1} alignItems={{ xs: 'stretch', lg: 'center' }}>
        <Button
          variant="contained"
          onClick={onCreateGame}
          startIcon={<Add />}
          size="small"
          sx={adminCombineSx(adminButtonSx, adminButtonToneSx.primary, { minWidth: { xs: '100%', sm: 164 } })}
        >
          Create New Game
        </Button>
      </Stack>
    </Box>
  </>
);

export default React.memo(StateGamesHeader);
